import { FC } from "react";

import Icons from "@app/assets/Icons";

import "./index.scss";

interface ToggleProps {
    heading?: string;
    isActive: boolean;
    onToggle?: (_val: boolean) => void;
    display?: string;
    isDisabled?: boolean;
    isIconRequired?: boolean;
}
const Toggle: FC<ToggleProps> = ({
    isActive,
    onToggle,
    isDisabled,
    display,
    heading: name,
    isIconRequired = true,
}) => {
    const onClick = () => {
        onToggle?.(!isActive);
    };

    const toggleClass = `${isActive ? "custom-toggle" : "custom-toggle--off"} ${
        isDisabled ? " custom-toggle--disabled" : ""
    }`;

    const toggleClassWithoutIcon = `${
        isActive ? "custom-toggle-without-icon" : "custom-toggle-without-icon--off"
    } ${isDisabled ? " custom-toggle--disabled" : ""}`;

    return (
        <>
            <h6 className='margin-bottom'>{name}</h6>
            <div
                className={isIconRequired ? toggleClass : toggleClassWithoutIcon}
                onClick={() => !isDisabled && onClick()}
            >
                {isActive ? (
                    <>
                        <span className={"custom-toggle__on"}>{display}</span>
                        <img
                            className={
                                isIconRequired
                                    ? "custom-toggle__tick-icon-on"
                                    : "custom-toggle__icon-on"
                            }
                            src={isIconRequired ? Icons.ToggleTickIcon : Icons.ToggleIcon}
                            alt='Toggle On'
                        />
                    </>
                ) : (
                    <>
                        <img
                            className={
                                isIconRequired
                                    ? "custom-toggle__cross-icon-off"
                                    : "custom-toggle__icon-off"
                            }
                            src={isIconRequired ? Icons.ToggleCrossIcon : Icons.ToggleIcon}
                            alt='Toggle Off'
                        />
                        <span className={"custom-toggle__off"}>{display} </span>
                    </>
                )}
            </div>
        </>
    );
};
export default Toggle;
